import { useQuery } from '@tanstack/react-query';
import { courierService } from '../services/courier';

export const courierKeys = {
  all: ['couriers'] as const,
};

export const useCouriers = () => {
  return useQuery({
    queryKey: courierKeys.all,
    queryFn: () => courierService.getAllCouriers(),
    staleTime: 10 * 60 * 1000, // 10 minutes cache
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
